module.exports = __webpack_public_path__ + "static/media/chair.87e0eb24.jpg";